<!-- Main container -->
@if (value$ | async; as constraint) {
  <div class="layout-row full">
    <app-property-input
      [name]="name"
      [label]="label"
      [showLabel]="showLabel"
      [property]="constraint.spec?.property"
      [required]="constraint.spec?.inputRequired"
      [singleSelection]="constraint.spec?.singleSelection"
      [tripleStateBoolean]="tripleStateBoolean"
      [allowedValues]="allowedValues"
      [values]="constraint.values"
      (valuesChange)="onConstraintValueUpdate($event)"
    >
    </app-property-input>
  </div>
}
